import * as React from "react";
import { useState, useEffect } from "react";
import ProfileCard from "../../common/profile_card/profile_card";
// import CustomCard from "../../common/custom_card/custom_card";
import DroneOrder from "../drone_order/drone_order";
import Header from "../../common/header/header";
import Footer from "../../common/footer/footer";
import SkeletonLoader from "../../common/skeleton/skeleton_loader";

const orders = [
  {
    orderNumber: "0985KJ",
    droneName: "DJI Phantom",
    orderedBy: "Florin G.",
    date: "08.04.2023",
    time: "00:18",
    location: "București, Romania",
    status: "Active",
    price: 130,
  },
  {
    orderNumber: "051JIK",
    droneName: "DJI Mavic series",
    orderedBy: "Martha L.",
    date: "05.04.2023",
    time: "00:18",
    location: "București, Romania",
    status: "Finalised",
    price: 42,
  },
  {
    orderNumber: "051JIK",
    droneName: "DJI Mavic series",
    orderedBy: "Martha L.",
    date: "05.04.2023",
    time: "00:18",
    location: "București, Romania",
    status: "Cancelled",
    price: 42,
  },
];

const MyOrders: React.FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <SkeletonLoader type="orders" />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow w-full flex justify-center">
        <div className="w-full max-w-7xl p-4">
          <Header />
          <div className="flex flex-col md:flex-row gap-6 py-20">
            <div className="md:w-1/3 space-y-4">
              <ProfileCard
                name="John Doe"
                memberSince="2022"
                location="București, Romania"
              />
              {/* <CustomCard
                imageSrc="/path-to-message-icon.png"
                imageAlt="Message"
                buttonText="Go to My Messages"
                backgroundColor="bg-bluePrimary"
              /> */}
            </div>
            <div className="md:w-2/3">
              <h1 className="font-ubuntu text-3xl font-bold mb-6">My Orders</h1>
              {orders.map((order, index) => (
                <DroneOrder key={index} order={order} />
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MyOrders;
